import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Wallets, WalletSelectList } from '../models';
import { WalletPublicService } from './wallet-public.service';


@Injectable({
  providedIn: 'root'
})
export class WalletPublicListResolverService  {

	constructor(
		private walletPublicService: WalletPublicService
	) { }

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Wallets> {
		return this.walletPublicService.getWalletForTransactionsFilter();
	}
}
